import useUiSettings from './useUiSettings';
import { useMemo } from 'react';

export type RightPaneConfig = {
  width: number;
  visible: boolean;
};

const useRightPaneConfiguration = (page: string) => {
  const [storedConfig, setStoredConfig, loading] =
    useUiSettings<RightPaneConfig>(page, 'rightPane');

  const config = useMemo<RightPaneConfig>(() => {
    return {
      visible: storedConfig?.visible ?? false,
      width: 700,
    };
  }, [storedConfig]);

  return {
    rightPaneConfig: config,
    setRightPaneConfig: setStoredConfig,
    loading,
  };
};

export default useRightPaneConfiguration;
